import { useCallback, useState } from "react";

import { SignInUnderWayError } from "../auth/errors";

/** What to say when going to Microsoft didn't start (#865). */
export function cantGoMessage(error: unknown): string {
  return error instanceof SignInUnderWayError
    ? "Already on the way to Microsoft. If nothing happens, reload the page."
    : "Couldn't go to Microsoft. Check your connection and try again.";
}

/**
 * Go to Microsoft, to sign in, renew or sign out, and what to say if that
 * didn't start: a double click, or a blocked redirect (#865). On success the
 * page leaves, so there's nothing to clear.
 */
export function useGoToMicrosoft(): {
  failed: string | null;
  go: (to: () => Promise<void>) => void;
} {
  const [failed, setFailed] = useState<string | null>(null);
  const go = useCallback((to: () => Promise<void>) => {
    to().catch((error: unknown) => {
      setFailed(cantGoMessage(error));
    });
  }, []);
  return { failed, go };
}
